var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":_vm.download}},[_vm._v("Download Specs")])}
var staticRenderFns = []

export { render, staticRenderFns }